<template lang="pug">
#slider
  swiper.swiper-box(:options='swiperOption', ref='swiper')
    swiper-slide.swiper-item(v-for="image in slideImages" ':style'='image.url | bgImage')
</template>
<script>
// import rdSwipe from 'vue-slide'
import { swiper, swiperSlide, swiperPlugins } from 'vue-awesome-swiper'
import axios from 'axios'
export default {
  data () {
    return {
      slideImages: [],
      swiperOption: {
        autoplay: 3000,
        setWrapperSize :true,
        // swiper callbacks
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
      }
    }
  },
  props: {
    dataApiUrl: {
      type: String,
      required: true
    }
  },
  created() {
    axios.get(this.dataApiUrl)
          .then((response) => {
            const data = response.data
            this.slideImages = data.result.photos
          })
          .catch((error) => console.log(error))
  },
  computed: {},
  ready () {},
  attached () {},
  methods: {},
  components: {
    swiper,
    swiperSlide
  }
}
</script>

<style lang="scss" scoped>
@import "global";
.swiper-box {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.swiper-item {
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  height: 0;
  padding-bottom: 600px;
}
#slider {
  .container {
    background: rgba(0, 0, 0, 0);
  }
}

@media (max-width: $grid-float-breakpoint-max) {
  .swiper-item {
    padding-bottom: 166px;
  }
}
</style>



// WEBPACK FOOTER //
// video_image_slider.vue?5b85f0dc